import { useState } from 'react';

export const useValidation = (schema) => {
    const [errors, setErrors] = useState({});

    const validate = async (data) => {
        try {
            await schema.validate(data, { abortEarly: false });
            setErrors({});
            return true;
        } catch (yupError) {
            const newErrors = {};
            yupError.inner.forEach(error => {
                newErrors[error.path] = error.message;
            });
            setErrors(newErrors);
            return false;
        }
    };

    const clearErrors = () => {
        setErrors({});
    }

    return [errors, validate, clearErrors];
};
